export class UnprocessableEntityError extends Error {
    constructor(message, validationErrors) {
        super(message);

        this.validationErrors = validationErrors;
    }
}
